module.exports = __webpack_public_path__ + "static/media/squirrel1.446bf425.jpg";